import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { usePerfilesContext } from "@conductor/context/PerfilesContext.jsx";
import { useAuth } from "@conductor/context/AuthContext.jsx";
import permissionsByPerfil from "./permissions.js";
import useToast from "@shared/hooks/useToast.jsx";
import Spinner from "@shared/componets/feedback/Spinner/Spinner.jsx";
import { GPSProvider } from "@conductor/context/GPSContext";

const PrivateRoute = () => {
	const { perfil, getAndSetPerfil } = usePerfilesContext();
	const { userData, loadingAuth, logOut } = useAuth();
	const { newToast } = useToast();
	const [loadingPrivateRouter, setLoadingPrivateRouter] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();


	useEffect(() => {
		if (loadingAuth) return;

		const run = async () => {
			const path = location.pathname;

			if (!userData) {
				newToast("La sesesion a vencido o no se encontraron datos", "info");
				navigate("/login");
				return;
			};

			let perfilData = perfil;
			if (!perfilData) {
				try {
					const res = await getAndSetPerfil();
					if (!res || !res.estado) {
						return logOut();
					};
					perfilData = res.response.perfil ?? null;
				} catch {
					perfilData = null;
				};
			};

			if (!perfilData) {
				newToast("La sesesion a vencido o no se encontraron datos", "info");
				return logOut();
			};

			const allow = permissionsByPerfil[perfilData]?.includes(path);

			if (!allow) {
				newToast("No tienes permisos para acceder", "info");
				navigate("/");
				return;
			};
			setLoadingPrivateRouter(false);
		};

		run();
	}, [loadingAuth]);

	// useEffect(() => {
	// 	const run = async () => {
	// 		const responseValidatePerfil = await validatePerfil();
	// 		console.log({ responseValidatePerfil });
	// 	};
	// 	run();
	// }, []);

	if (loadingPrivateRouter) {
		return <Spinner />;
	};

	return <GPSProvider><Outlet /></GPSProvider>;
};

export default PrivateRoute;